import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";
import { mediaTypes } from "/WebInterface/new-ui/assets/js/constants.js";

const slideShowTemplate = htmlE`
  <span class="slideshow-pageTotal text-base"></span>
  <div class="slideshow-close"><i class="icon-remove"></i></div>
  <div class="slideshow-player-section">
    </div>
    <div class="slideshow-footer">
      <p class="name-bar text-base"></p>
      <div class="control-bar info-bar"></div>
      <div class="preview"></div>
    </div>
  </div>
`;

const controlBarTemplate = htmlE`
  ${({ slideShowDelayTime }) => {
    return `
      <div class="is-flex is-flex-direction-column is-align-items-center is-absolute" style="left:10px;">
        <input
          id="delaySlider"
          value="${slideShowDelayTime}"
          min="1"
          max="15"
          type="range"
          step="1"
        />

        <p class="text-primaryMain text-sm mt-1">(Delay <span id="slideshowIntervalDelay">${slideShowDelayTime}</span> sec)</p>
      </div>
    `;
  }}
  <button data-tooltip="deleteSlide" id="delete-slide" class="slider-icons" aria-label="delete-btn">
    <i class="icon-trash"></i>
  </button>
  <button data-tooltip="refreshSlideshow" id="refresh-slideshow" class="slider-icons" aria-label="refresh-btn">
    <i class="icon-refresh"></i>
  </button>
  <button data-tooltip="Download" id="download-quick-view" class="slider-icons" aria-label="download-btn">
    <i class="icon-download"></i>
  </button>
  ${({ mediaType }) => {
    if (mediaType === mediaTypes.IMAGE) {
      return `<button data-tooltip="zoomIn" id="zoomIn" class="slider-icons" aria-label="zoom-btn">
            <i class="icon-plus"></i>
          </button>
          <button data-tooltip="zoomOut" id="zoomOut" class="slider-icons" aria-label="minus-btn">
            <i class="icon-minus"></i>
          </button>`;
    }
  }}
  <button data-tooltip="previousSlide" id="left-angle" class="slider-icons" aria-label="forward-btn">
    <i class="icon-chevron-left"></i>
  </button>
  <button id="play-or-pause-slideshow" class="slideshow-icon" aria-label="play-or-pause-slideshow-btn">
    ${({ slideShowStatus, playSlideshowText, pauseSlideshowText }) => {
      if (slideShowStatus) {
        return `<i class="icon-pause"></i> <span data-i18n-key="pauseSlideshow">${pauseSlideshowText}</span>`;
      } else {
        return `<i class="icon-play"></i> <span data-i18n-key="playSlideshow">${playSlideshowText}</span>`;
      }
    }}
  </button>
  <button data-tooltip="nextSlide" id="right-angle" class="slider-icons" aria-label="backward-btn">
    <i class="icon-chevron-right"></i>
  </button>
  ${({ mediaType }) => {
    if (mediaType === mediaTypes.IMAGE) {
      return `<button data-tooltip="rotateImageLeft" id="leftRotate" class="slider-icons" aria-label="undo-btn">
            <i class="icon-undo"></i>
          </button>
          <button data-tooltip="rotateImageRight" id="rightRotate" class="slider-icons" aria-label="rotate-btn">
            <i class="icon-repeat"></i>
          </button>`;
    }
  }}
  <button data-tooltip="Add To Basket" id="add-to-basket-quick-view" class="slider-icons" aria-label="add-to-basket-btn">
    <i class="icon-plus-sign"></i>
  </button>
  <button data-tooltip="Edit Keywords" id="edit-keywords-quick-view" class="slider-icons" aria-label="edit-keywords-btn">
    <i class="icon-tags"></i>
  </button>
  <button data-tooltip="toggleFullScreen" id="fullscreen-slideshow" class="slider-icons" aria-label="fullscreen-slideshow-btn">
    ${({ isSlideShowFullScreen }) => {
      if (isSlideShowFullScreen) {
        return `<i class="icon-resize-small"></i>`;
      } else {
        return `<i class="icon-resize-full"></i>`;
      }
    }}
  </button>

`;

export default { slideShowTemplate, controlBarTemplate };
